export default __webpack_public_path__ + "static/media/pricing-seven-bg.348b0777.png";